import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "搜索结果", to: "/search" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

const categoryLinks = [
  { label: "明星动态", to: "/category/star-latest" },
  { label: "网络热议", to: "/category/net-buzz" },
  { label: "热门视频", to: "/category/hot-review" },
  { label: "深度解析", to: "/category/deep-insight" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-background-50">
                黑料视频
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              聚焦娱乐八卦与网络热点的视频资讯平台，用视频还原每条热闻的来龙去脉，让你看到的每一次刷屏都有迹可循。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://169hj.cn"
                target="_blank"
                rel="noreferrer"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 hover:bg-primary-800 cursor-pointer"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                aria-label="视频频道"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 hover:bg-primary-800 cursor-pointer"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 hover:bg-primary-800 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com"
                target="_blank"
                rel="noreferrer"
                aria-label="短视频"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 hover:bg-primary-800 cursor-pointer"
              >
                <i className="ri-music-2-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              快速导航
            </h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              视频分类
            </h4>
            <ul className="mt-4 space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              联系我们
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                contact@heiliaovideo.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                400-660-8899
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                北京市朝阳区传媒创意园 A 座 12 层
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                周一至周五 09:00 - 18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-900 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {year} 黑料视频 · 本网站内容为演示数据，仅供产品展示使用
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-400">
            <span className="text-background-500">友情链接：</span>
            <a href="https://169hj.cn" target="_blank" rel="noreferrer" className="hover:text-accent-400 cursor-pointer">微博</a>
            <a href="https://www.bilibili.com" target="_blank" rel="noreferrer" className="hover:text-accent-400 cursor-pointer">哔哩哔哩</a>
            <a href="https://www.douban.com" target="_blank" rel="noreferrer" className="hover:text-accent-400 cursor-pointer">豆瓣电影</a>
            <Link to="/about" className="hover:text-accent-400 cursor-pointer">隐私政策</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}